import React from "react";
import { useRoutes } from "react-router-dom";
import { PATHS } from "./utils";
import HomePage from "./pages/HomePage";
import AboutPage from "./pages/AboutPage";
import ServicesPage from "./pages/ServicesPage";
import PortfolioPage from "./pages/PortfolioPage";
import JoinUsPage from "./pages/JoinUsPage";
import ContactPage from "./pages/ContactPage";
import PrivacyPolicyPage from "./pages/PrivacyPolicyPage";
import PortfolioInfoPage from "./pages/PortfolioInfoPage";
import NotFoundPage from "./pages/NotFoundPage";
import ServiceInfoPage from "./pages/ServiceInfoPage";
import NoDataPage from "./pages/NoDataPage";
import IndustriesPage from "./pages/IndustriesPage";
import IndustryInfoPage from "./pages/IndustryInfoPage";

const Router = () => {
  const routes = [
    {
      path: PATHS.home,
      element: <HomePage />,
    },
    {
      path: PATHS.frontpage,
      element: <HomePage />,
    },
    {
      path: PATHS.about,
      element: <AboutPage />,
    },
    {
      path: PATHS.services,
      element: <ServicesPage />,
    },
    {
      path: PATHS.portfolio,
      element: <PortfolioPage />,
    },
    {
      path: PATHS.industries,
      element: <IndustriesPage />,
    },
    {
      path: PATHS.joinUs,
      element: <JoinUsPage />,
    },
    {
      path: PATHS.contactUs,
      element: <ContactPage />,
    },
    {
      path: PATHS.privacyPolicy,
      element: <PrivacyPolicyPage />,
    },
    // Legacy routes for backward compatibility
    {
      path: PATHS.portfolioInfo,
      element: <PortfolioInfoPage />,
    },
    {
      path: PATHS.projectInfoWithSlug,
      element: <PortfolioInfoPage />,
    },
    {
      path: PATHS.serviceInfo,
      element: <ServiceInfoPage />,
    },
    {
      path: PATHS.serviceInfoWithSlug,
      element: <ServiceInfoPage />,
    },
    {
      path: PATHS.industryInfo,
      element: <IndustryInfoPage />,
    },
    // New routes with navigation item names
    {
      path: PATHS.portfolioWithSlug,
      element: <PortfolioInfoPage />,
    },
    {
      path: PATHS.servicesWithSlug,
      element: <ServiceInfoPage />,
    },
    {
      path: PATHS.industriesWithSlug,
      element: <IndustryInfoPage />,
    },
    {
      path: PATHS.notFoundPage,
      element: <NotFoundPage />,
    },
    {
      path: PATHS.noDataFoundPage,
      element: <NoDataPage />,
    },
  ];

  const element = useRoutes(routes);
  return element;
};

export default Router;
